// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vM1it","rt":"styles_rt__Yz5gV","arrow":"styles_arrow__NDxAI","presents":"styles_presents__REh+D","content":"styles_content__nUMwS"};